import { AfsPageOptions } from '../../shared/types/ast';
import { getConfig } from '../config';

const STYLE_ID = {
    DESKTOP: '5268803732',
    MOBILE: '4302767753',
};

const afs = {
    pubId: 'partner-pub-4700071094164059',
    query: 'search',
};

export function setupAfs() {
    const { deviceType, pageType, vertical } = getConfig();

    if (pageType === 'result' && vertical === 'bap') {
        const pageOptions: AfsPageOptions = {
            pubId: afs.pubId,
            query: afs.query, // TODO: Fix this
            styleId:
                deviceType === 'mobile' ? STYLE_ID.MOBILE : STYLE_ID.DESKTOP,
            adsafe: 'high',
            resultsPageBaseUrl: window.location.href,
            resultsPageQueryParam: 'q',
            number: 1,
        };

        const adblock1 = {
            container: 'afscontainer1',
        };

        try {
            window._googCsa('ads', pageOptions, adblock1);
        } catch (error) {
            console.error('Error in google ad sense [for search]: ', error);
        }
    }
}
